/** Editors' floating "+" → choose "Æfingaröð" (recurring) or "Stakur viðburður" (one-off). */
import { CalendarPlus, Plus, Repeat } from 'lucide-react';
import { useState } from 'react';
import { Sheet } from '../../components/ui';
import { useT } from '../../i18n';
import { EventEditor } from './EventEditor';
import { SeriesEditor } from './SeriesEditor';
import { ChoiceButton } from './shared';

export function NewEventFab({ defaultDate, onCreated }: { defaultDate?: string; onCreated?: (date: string) => void }) {
  const t = useT();
  const [step, setStep] = useState<'closed' | 'choose' | 'series' | 'event'>('closed');
  const close = () => setStep('closed');
  return (
    <>
      <button
        type="button"
        onClick={() => setStep('choose')}
        aria-label={t('calendar.new.title')}
        className="fixed right-4 bottom-[calc(var(--safe-bottom)+80px)] z-30 inline-flex min-h-16 min-w-16 items-center justify-center gap-2 rounded-full bg-[var(--accent)] px-5 text-[18px] font-semibold text-[var(--accent-ink)] shadow-lg transition active:brightness-95 md:right-8 md:bottom-[calc(var(--safe-bottom)+32px)]"
      >
        <Plus className="size-7" aria-hidden strokeWidth={2.5} />
        <span className="hidden md:inline">{t('calendar.new.title')}</span>
      </button>

      <Sheet open={step === 'choose'} onClose={close} title={t('calendar.new.title')}>
        <div className="flex flex-col gap-3 py-2">
          <ChoiceButton icon={Repeat} title={t('calendar.new.series')} desc={t('calendar.new.series_desc')} onClick={() => setStep('series')} />
          <ChoiceButton icon={CalendarPlus} title={t('calendar.new.single')} desc={t('calendar.new.single_desc')} onClick={() => setStep('event')} />
        </div>
      </Sheet>

      {step === 'series' ? <SeriesEditor mode={{ kind: 'create' }} onClose={close} onSaved={(r) => onCreated?.(r.from)} /> : null}
      {step === 'event' ? <EventEditor mode={{ kind: 'create', date: defaultDate }} onClose={close} onSaved={(r) => onCreated?.(r.date)} /> : null}
    </>
  );
}
